<zuper-drawer class="border-l border-gray-300 shadow-none non-job-event-create-form" [name]="drawerName" [mode]="'over'"
    [position]="'right'" [transparentOverlay]="false" (openedChanged)="drawerOpenedChanged($event)"
    [hideOnClickOutside]="false" [fixed]="true">
    <div class="drawer-content w-full relative" *ngIf="openDrawer">
        <div>
            <div class="relative w-full px-6 p-4 bg-accent-100 dark:bg-accent-700 z-0">
                <div class="flex items-center justify-between w-full">
                    <h5 class="font-semibold px-2.5 text-xl">
                        {{options?.header | translate}}
                    </h5>
                    <div class="flex items-center">
                        <i (click)="closeDrawer()"
                            class="ti ti-x text-2xl ml-3 p-1.5 hover:bg-gray-200 rounded-full"></i>
                    </div>
                </div>
            </div>
        </div>
        <form [formGroup]="nonJobEventForm" autocomplete="off" id="non-job-event-form">
            <div class="main-container w-full zuper-scrollbar p-4">
                <!-- Primary Details -->
                <div class="rounded-xl border border-gray-200 primary-font text-gray-700 font-normal text-base">
                    <div class="m-3 ml-5">
                        <div class="font-semibold flex items-center space-x-2">
                            <i class="ti ti-box-padding text-2xl"></i>
                            <span class="header-text">{{"text.primary_details" | translate}}</span>
                        </div>
                    </div>
                    <div>
                        <!-- Event Name -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5 border-t border-gray-200">
                            <div
                                class="col-span-2 break-words flex items-center text-base font-medium primary-font text-gray-500">
                                {{"non_job_event.create.name" | translate}} <span class="mandatory-field">*</span>
                            </div>
                            <div class="col-span-4 break-words">
                                <input type="text" autocomplete="off"
                                    formControlName="eventName"
                                    class="block w-full rounded-md border border-gray-300 bg-white px-4 py-3 leading-none text-base"
                                    [ngClass]="nonJobEventForm.controls?.eventName?.errors?.required && nonJobEventForm.controls?.eventName?.touched || nonJobEventForm.controls?.eventName?.errors?.maxlength ? 'border-red-600': 'focus:border-indigo-500'"
                                    placeholder="{{ 'non_job_event.create.name.placeholder' | translate}}">
                                <p class="text-red-500 text-base mt-1"
                                    *ngIf="nonJobEventForm.controls?.eventName?.errors?.required && nonJobEventForm.controls?.eventName?.touched">
                                    {{'text.field_is_required'| translate}}</p>
                                <p class="text-red-500 text-base mt-1"
                                    *ngIf="nonJobEventForm.controls?.eventName?.errors?.maxlength">
                                    {{'non_job_event.create.name.max_length.error'| translate}}</p>
                            </div>
                        </div>
                        <!-- Category -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5 border-t border-gray-200">
                            <div
                                class="col-span-2 break-words flex items-center text-base font-medium primary-font text-gray-500">
                                {{"category.text" | translate}} <span class="mandatory-field">*</span>
                            </div>
                            <div class="col-span-4 break-words">
                                <div class="w-full">
                                    <ng-select [multiple]="false" #categorySelectorRef [loading]="categoryFetching"
                                        [closeOnSelect]="true" formControlName="category" [searchable]="true"
                                        placeholder="{{'non_job_event.create.category.placeholder' | translate}}"
                                        [clearable]="false" formControlName="category" [hideSelected]="false"
                                        (close)="categorySelectorRef.blur()">
                                        <ng-option [value]="category?.category_uid"
                                            *ngFor="let category of $categories | async;">
                                            <div class="primary-font text-base flex items-center space-x-2">
                                                <div class="min-w-fit">
                                                    <div class="w-3.5 h-3.5 mb-0.5 rounded-sm"
                                                        [style.background]="category?.category_color || '#e67e22'">
                                                    </div>
                                                </div>
                                                <span>{{category?.category_name}}</span>
                                            </div>
                                        </ng-option>
                                        <ng-template ng-footer-tmp *ngIf="userRole === 'ADMIN'">
                                            <div class="primary-font text-base flex p-2 justify-center items-center cursor-pointer font-medium text-blue"
                                                (click)="createNewCategory()">
                                                {{'new.job.category.create_new' | translate}}
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <p class="text-red-500 text-base mt-1"
                                    *ngIf="nonJobEventForm.controls?.category?.errors?.required && nonJobEventForm.controls?.category?.touched">
                                    {{'text.field_is_required'| translate}}</p>
                            </div>
                        </div>
                        <!-- Description -->
                        <div class="grid grid-cols-6 gap-x-4 gap-y-1 px-6 py-5 border-t border-gray-200">
                            <div
                                class="col-span-2 break-words flex items-center text-base font-medium primary-font text-gray-500">
                                {{"non_job_event.create.description" | translate}}
                            </div>
                            <div class="col-span-4 break-words h-60">
                                <text-editor [editorData]="nonJobEventForm.controls.description" [options]="textEditorOptions"
                                    style="font-size: 14px;">
                                </text-editor>
                            </div>
                            <div class="col-span-2"> </div>
                            <div class="col-span-4 break-words">
                                <p class="text-red-500 text-base my-2" *ngIf="nonJobEventForm.controls?.description?.errors?.maxPlainTextLength">
                                    {{'non_job_event.create.description.max_length.error'| translate}}</p>
                            </div>
                        </div>
                        <!-- Attendees -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5 border-t border-gray-200">
                            <div
                                class="col-span-2 break-words flex items-start mt-2 text-base font-medium primary-font text-gray-500">
                                {{"non_job_event.create.attendees" | translate}}
                            </div>
                            <div class="col-span-4 break-words">
                                <div class="w-full">
                                    <ng-select [items]="$employees | async" [multiple]="true"
                                        [loading]="employeeFetching" [closeOnSelect]="false" (blur)="employeeValueSubject.next('')"
                                        [typeahead]="employeeValueSubject" (clear)="onEmployeeClear()"
                                        (search)="onEmployeeSearch()" (change)="onEmployeeChange()"
                                        (scrollToEnd)="onEmployeeScrollToEnd()" [searchable]="true"
                                        placeholder="{{'text.search_user' | translate}}" [clearable]="false"
                                        formControlName="assignedTo" [hideSelected]="false">
                                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                            <div class="primary-font text-base flex items-center">
                                                <input id="item-{{index}}" type="checkbox" class="mr-4"
                                                    [checked]="isEmployeeAssigned(item)"
                                                    (change)="nonJobEventForm.controls.assignedTo.value?.length ? userSelectionChanged($event, item) : $event.stopPropagation()" />
                                                <div class="primary-font text-base text-gray-600 flex items-center">
                                                    <img *ngIf="item?.hasValidProfilePicture"
                                                        class="h-8 w-8 relative rounded-md mr-2"
                                                        src="{{item?.profile_picture}}"
                                                        alt="{{item?.first_name}} {{item?.last_name ?? ''}}"
                                                        title="{{item?.first_name}} {{item?.last_name ?? ''}}">
                                                    <div *ngIf="!item?.hasValidProfilePicture"
                                                        matTooltip="{{item?.first_name}} {{item?.last_name ?? ''}}"
                                                        class="flex flex-shrink-0 bg-gray-200 rounded-md items-center text-base justify-center h-8 w-8 mr-2">
                                                        {{item?.first_name ? item?.first_name.slice(0,1): ''}}
                                                    </div>
                                                    <p class="font-semibold">
                                                        {{item.first_name}} {{item.last_name ?? ''}}
                                                    </p>
                                                </div>
                                            </div>
                                        </ng-template>
                                        <ng-template ng-multi-label-tmp>
                                            <span style="display:block" *ngIf="!employeePagination.keyword"
                                                class="ng-placeholder">{{'text.search_user' |
                                                translate}}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <div class="divide-y divide-gray-200 mt-2 max-h-52 overflow-y-auto zuper-scrollbar"
                                    *ngIf="nonJobEventForm?.controls?.assignedTo?.value?.length">
                                    <ng-container
                                        *ngFor="let user of nonJobEventForm?.controls?.assignedTo?.value;let i=index">
                                        <div class="flex items-center py-1.5" *ngIf="user">
                                            <img *ngIf="user?.hasValidProfilePicture"
                                                class="h-10 w-10 relative rounded-md mr-2"
                                                src="{{user?.profile_picture}}"
                                                alt="{{user?.first_name}} {{user?.last_name ?? ''}}"
                                                title="{{user?.first_name}} {{user?.last_name ?? ''}}">
                                            <div *ngIf="!user?.hasValidProfilePicture"
                                                matTooltip="{{user?.first_name}} {{user?.last_name ?? ''}}"
                                                class="flex flex-shrink-0 bg-gray-200 rounded-md items-center text-base justify-center h-10 w-10 mr-2">
                                                {{user?.first_name ? user?.first_name.slice(0,1): ''}}
                                            </div>
                                            <div class="w-2/3 truncate">
                                                <p class="text-base font-medium primary-font">
                                                    {{user?.first_name}} {{user?.last_name ?? ''}}
                                                </p>
                                            </div>
                                            <div class="flex ml-auto items-center">
                                                <a matTooltip="{{'text.unassign' | translate}}"
                                                    (click)="unassignEmployee(user)"
                                                    class="flex flex-shrink-0 hover:bg-red-100 rounded-full items-center justify-center h-8 w-8 cursor-pointer">
                                                    <em class="ti ti-user-x text-xl text-red-500"></em>
                                                </a>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <!-- Event Address -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-6 border-t border-gray-200"
                            [ngClass]="{'bg-gray-100 pointer-events-none disable-edit' : isMasterRouteEdit}">
                            <div
                                class="col-span-2 break-words flex items-center text-base font-medium primary-font text-gray-500">
                                {{"non_job_event.create.event_address" | translate}}
                            </div>
                            <div class="col-span-4 break-words flex items-start flex-col">
                                <div class="relative w-full">
                                    <input type="text" #eventLocationElementRef
                                        [readonly]="eventLocationElementRef?.focus" formControlName="eventAddressText"
                                        class="block truncate w-full pr-10 rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-4 py-3 leading-none text-base"
                                        placeholder="{{ 'non_job_event.create.event_address.placeholder' | translate}}"
                                        (click)="openMapLocationSelectorDialog()">
                                    <span class="absolute inset-y-0 right-0 pr-3 flex items-center">
                                        <i class="ti ti-chevron-right mr-2"></i>
                                    </span>
                                    <p class="text-blue-500 text-base mt-1 underline cursor-pointer absolute right-2 -top-6"
                                        (click)="clearEventAddress()"
                                        *ngIf="nonJobEventForm?.controls?.eventAddressText?.value">
                                        {{'overall_search.recently_viewed.clear' | translate}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Schedule -->
                <div class="rounded-xl border border-gray-200 mt-4 primary-font text-base text-gray-500 font-normal">
                    <div class="m-3 ml-5 flex justify-between" formGroupName="schedule">
                        <div class="flex items-center font-semibold space-x-2">
                            <i class="ti ti-calendar text-2xl"></i>
                            <span class="header-text">{{"text.schedule" | translate}}</span>
                        </div>
                        <!-- All day -->
                        <div class="min-w-fit custom-slide-toggle flex items-center space-x-2">
                            <mat-slide-toggle #allDayToggleRef [disableRipple]="true" [color]="'primary'"
                                formControlName="allDay"></mat-slide-toggle>
                            <span class="cursor-pointer select-none font-medium text-gray-700"
                                (click)="allDayToggleRef?.toggle()">{{'newtimeoff.apply.partial.label' |
                                translate}}</span>
                        </div>
                    </div>

                    <!-- Scheduled on -->
                    <div formGroupName="schedule" class="primary-font text-base text-gray-700 font-normal">
                        <div class="grid grid-cols-6 gap-4 px-6 pt-5 border-t border-gray-200">
                            <div class="col-span-2 break-words flex items-center text-base font-medium primary-font text-gray-500">
                                {{"text.schedule_on" | translate}} <span
                                    class="mandatory-field">*</span>
                            </div>
                            <!-- Event Date -->
                            <div class="col-span-4 break-words">
                                <div class="col-span-3 xl:col-span-2 relative">
                                    <div class="flex items-center space-x-1 border border-gray-300 rounded-lg p-2 px-3">
                                        <span><i class="ti ti-calendar text-2xl text-gray-500"></i></span>
                                        <input readonly [matDatepicker]="eventDatePicker"
                                            [datePickerFormat]="dateFormat" formControlName="eventDate"
                                            class="block text-gray-600 w-full pt-0.5 px-0.5 bg-white cursor-pointer text-base font-medium"
                                            placeholder="{{'non_job_event.create.event_date.placeholder' | translate}}"
                                            (click)="eventDatePicker.open()">
                                        <mat-datepicker #eventDatePicker></mat-datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Event Time -->
                        <div class="grid grid-cols-6 px-6" *ngIf="!allDayToggleRef?.checked"
                            [ngClass]="enableMultipleTimezoneSwitching ? 'pt-5': 'pt-5 pb-3'">
                            <div class="col-span-2"></div>
                            <div class="gap-4 flex col-span-4 ml-1.5">
                                <div class="col-span-2 break-words w-full">
                                    <div class="col-span-3 xl:col-span-2 relative">
                                        <mat-form-field appearance="fill" class="w-full" [floatLabel]="'always'">
                                            <div class="flex items-center space-x-1">
                                                <i class="ti ti-clock text-2xl text-gray-500" [matMenuTriggerFor]="startTimePicker"></i>
                                                <input matInput readonly class="cursor-pointer" placeholder="{{'text.from' | titlecase | translate}}"
                                                    formControlName="fromTime" [matMenuTriggerFor]="startTimePicker" />
                                            </div>
                                            <mat-menu #startTimePicker="matMenu">
                                                <div class="flex flex-col">
                                                    <div class="flex justify-center">
                                                        <ngx-mat-timepicker (click)="$event.stopPropagation()"
                                                            [disabled]="false" [showSpinners]="true" [stepHour]="1"
                                                            [stepMinute]="1" [showSeconds]="false"
                                                            [enableMeridian]="isMeridian"
                                                            formControlName="fromTimePicker">
                                                        </ngx-mat-timepicker>
                                                    </div>
                                                    <div class="flex justify-center">
                                                        <button mat-stroked-button>
                                                            {{'text.ok' | translate}}
                                                        </button>
                                                    </div>
                                                </div>
                                            </mat-menu>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-span-2 break-words w-full">
                                    <div class="col-span-3 xl:col-span-2 relative">
                                        <mat-form-field appearance="fill" class="w-full" [floatLabel]="'always'">
                                            <div class="flex items-center space-x-1">
                                                <i class="ti ti-clock text-2xl text-gray-500" [matMenuTriggerFor]="endTimePicker"></i>
                                                <input matInput readonly class="cursor-pointer" placeholder="{{'text.to' | titlecase | translate}}"
                                                    formControlName="toTime" [matMenuTriggerFor]="endTimePicker" />
                                            </div>
                                            <mat-menu #endTimePicker="matMenu">
                                                <div class="flex flex-col">
                                                    <div class="flex justify-center">
                                                        <ngx-mat-timepicker (click)="$event.stopPropagation()"
                                                            [disabled]="false" [showSpinners]="true" [stepHour]="1"
                                                            [stepMinute]="1" [showSeconds]="false"
                                                            [enableMeridian]="isMeridian"
                                                            formControlName="toTimePicker">
                                                        </ngx-mat-timepicker>
                                                    </div>
                                                    <div class="flex justify-center">
                                                        <button mat-stroked-button>
                                                            {{'text.ok' | translate}}
                                                        </button>
                                                    </div>
                                                </div>
                                            </mat-menu>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <p class="text-red-500 ml-auto col-span-6"
                                *ngIf="nonJobEventForm.controls?.schedule?.controls?.fromTime?.errors?.invalid || nonJobEventForm.controls?.schedule?.controls?.toTime?.errors?.invalid">
                                {{'dispatchBoard.scheduler.reschedule.start_end_time_invalid' | translate}}
                            </p>
                        </div>
                        <!-- Timezone -->
                        <div class="grid grid-cols-6 px-6 py-5 pt-3" *ngIf="enableMultipleTimezoneSwitching">
                            <div class="col-span-2"></div>
                            <div class="col-span-4 break-words ml-1">
                                <div class="col-span-3 xl:col-span-2 relative">
                                    <ng-select #scheduleTimezoneRef class="cursor-pointer static" [appendTo]="body"
                                        formControlName="timezone" [clearable]="false" [multiple]="false"
                                        [virtualScroll]="true" [hideSelected]="false" (change)="scheduleTimezoneRef.blur();">
                                        <ng-option *ngFor="let timezone of $timezones | async"
                                            [value]="timezone?.key">
                                            <span title="{{timezone?.name || ''}}">{{timezone?.name || ''}}</span></ng-option>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <!-- Event schedule notes -->
                         <div *ngIf="eventStartEndTimeText && allDayToggleRef?.checked" class="px-6 pb-3 text-base primary-font font-medium text-gray-700 ng-star-inserted" [ngClass]="enableMultipleTimezoneSwitching ? 'pt-0': 'pt-5'">
                            <span>{{eventStartEndTimeText}}</span>
                         </div>
                    </div>
                    <!-- Availability -->
                    <div class="grid grid-cols-6 gap-4 px-6 py-5 border-t border-gray-200 primary-font text-base text-gray-700 font-normal">
                        <div
                            class="col-span-2 break-words flex space-x-2 items-center text-base font-medium primary-font text-gray-500">
                            <span>{{"non_job_event.create.availability" | translate}}</span>
                            <i class="ti ti-help text-2xl text-gray-500" [matTooltip]="tooltipContent.availability"
                                matTooltipPosition="above" matTooltipClass="help-tooltip"></i>
                        </div>
                        <div class="col-span-4 break-words">
                            <div class="flex availability-select">
                                <mat-radio-group [disableRipple]="true" formControlName="availability">
                                    <mat-radio-button disableRipple="true" value="BUSY" class="font-medium">{{"non_job_event.create.availability.busy" | translate}}</mat-radio-button>
                                    <mat-radio-button disableRipple="true" class="ml-6 font-medium" value="FREE">{{"non_job_event.create.availability.free" | translate}}</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                    <!-- Notify attendees -->
                    <div class="grid grid-cols-6 gap-4 px-6 py-5 border-t border-gray-200 primary-font text-base text-gray-700 font-normal">
                        <div class="col-span-6 break-words flex items-center text-base font-medium primary-font text-gray-700 cursor-pointer">
                            <input id="notifyAttendees" type="checkbox" formControlName="notifyAttendees"
                                class="cursor-pointer w-4 h-4 mr-2.5 text-blue bg-gray-100 border-gray-300 rounded-lg focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"/>
                            <label for="notifyAttendees" class="cursor-pointer select-none text-gray-500">{{"non_job_event.create.notify_attendees" | translate}}</label>
                            <i class="ti ti-help text-2xl text-gray-500 ml-2" [matTooltip]="tooltipContent.notifyAttendees"
                                matTooltipPosition="above" matTooltipClass="help-tooltip"></i>
                        </div>
                    </div>
                    
                    <!-- Recurring options -->
                     <div class="border-t border-gray-200 primary-font text-base text-gray-700 font-normal" *ngIf="options.state === 'new' || (options.state === 'edit' && options.editType !== 'SINGLE_EVENT')">
                         <app-recurrence-rule [recurrenceForm]="nonJobEventForm" [today]="nonJobEventForm?.value?.schedule?.eventDate" [options]="recurrenceData?.options" [timezone]="selectedTimezone"> </app-recurrence-rule>
                     </div>
                </div>
            </div>
            <!-- Footer -->
            <div
                class="w-full absolute bottom-0 shadow-sm primary-font font-noraml text-base border-t py-4 px-2 bg-white">
                <div class="w-full px-4 flex justify-end items-center gap-4 h-full">
                    <button (click)="closeDrawer()" type="button"
                        class="px-6 items-center py-2 border border-gray-300 shadow-sm rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                        {{'cancel.text' | translate}}
                    </button>

                    <button type="submit" (click)="onSubmitForm()" [disabled]="isLoading"
                        class="bg-primary px-6 items-center py-2 border-gray-300 shadow-sm text-white rounded-md text-white-600 focus:outline-none">
                        <ng-container [ngSwitch]="options?.state">
                            <ng-container *ngSwitchCase="'edit'">
                                {{'update' | translate}}
                            </ng-container>
                            <ng-container *ngSwitchCase="'new'">
                                {{'create' | translate}}
                            </ng-container>
                        </ng-container>
                    </button>
                </div>
            </div>
        </form>

    </div>
</zuper-drawer>